import type { IconProps } from './types';
import './icons.css';

export default function FilterCircle({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={`icon icon-filter-circle ${className || ''}`}
    >
      <rect x=".5" y=".5" width="15" height="15" rx="7.5" stroke="#9EA7AE" />
      <path
        fill="#171819"
        d="M7.624 10.57 5.226 7.83A.5.5 0 0 1 5.602 7h4.796a.5.5 0 0 1 .376.83l-2.398 2.74a.5.5 0 0 1-.752 0Z"
      />
    </svg>
  );
}
